module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-proposal02.ae03bd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/grac-oidd-competition-proposal02.jpg
// module id = kXie
// module chunks = 0